import styled from 'styled-components';

export const Container = styled.div`
	width: 100%;
	margin-top: 2rem;
	display: grid;
	grid-gap: 10px;

	& > button {
		margin-top: 60px;
	}
`;

export const Subtitle = styled.p`
	text-align: center;
	width: 100%;
	font-size: 11px;
`;

export const ItemContainer = styled.div<{ variant?: boolean }>`
	height: 40px;
	margin-bottom: ${({ variant }) => (variant ? '30px' : '20px')};
`;

export const ErrorText = styled.p`
	height: 40px;
	font-size: 10px;
	color: tomato;
	margin: 5px 0 5px 4px;
`;
